// GENERATED FILE - DO NOT MODIFY

export enum GetPolicyBundlesSortColumnDto {
    Name = "Name",
    NumberOfTeams = "NumberOfTeams",
}